/**
 * View-only root position smoothing — damps soft-sep / integrate jitter
 * without changing sim x/y.
 */

export type DisplayPos = { x: number; y: number };

/**
 * Exponential chase toward sim target. Snap when error ≥ snapPx (spawn/teleport).
 * `followHz` is the smoothing bandwidth (higher = snappier).
 */
export function stepDisplayPos(
  curX: number,
  curY: number,
  targetX: number,
  targetY: number,
  followHz: number,
  snapPx: number,
  dt: number,
): DisplayPos {
  const dx = targetX - curX;
  const dy = targetY - curY;
  const dist = Math.hypot(dx, dy);
  if (dist < 1e-6) return { x: targetX, y: targetY };
  const snap = Math.max(1, snapPx);
  if (dist >= snap) return { x: targetX, y: targetY };
  const hz = Math.max(0.5, followHz);
  const alpha = 1 - Math.exp(-hz * Math.max(0, dt));
  return { x: curX + dx * alpha, y: curY + dy * alpha };
}
